var map = {
	"./fun-icon-0.png": "9830",
	"./fun-icon-1.png": "a32d",
	"./fun-icon-2.png": "9b51",
	"./fun-icon-3.png": "7a96",
	"./fun-icon-4.png": "d725",
	"./fun-icon-41.png": "0eeb",
	"./fun-icon-5.png": "0400"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "60e8";